// src/world/maps/rutaAurelia.ts — Ruta Aurelia 32x28 (aventurera, natural, misteriosa)
import { parseLayout } from '../tiles.js';
import type { Warp, SignDef } from './villaAurelia.js';
import type { ZoneId } from '../../data/gameConfig.js';

export const RUTA_SIZE = { w: 32, h: 28 };

const LAYOUT: string[] = [
  // 0         1         2         3
  // 01234567890123456789012345678901
  "TTTTTTTTTTTTTTPPPTTTTTTTTTTTTTTT", //0 entrada norte desde Villa (15-17)
  "TGGGGGGGGGGGGGPGGPGGGGGGGGGGGGGT", //1
  "TGGfGGGGGGGGGPGGPGGGGGRGGGGfGGT", //2
  "TGGGGGGGGGGGGPGGPGGGGGGGGGGGGGT", //3 puente zona?
  "TGGGGGGGGGGGBBBBBBGGGGGGGGGfGGT", //4 puente sobre agua horizontal
  "TWWWWWWWWWWBUUUUBWWWWWWWWWWWWWT", //5 agua bajo puente
  "TWWWWWWWWWWBUUUUBWWWWWWWWWWWWWT", //6
  "TGGGGGGGGGGGBBBBBBGGGGGGGGGGGGT", //7 después del puente
  "TGGfGGGGhGGGPGGPGGGGhGGGGGGGGGT", //8 hierba alta lateral
  "TGGGGGGGhGGGPGGPGGGGhGGGGGGGfGT", //9
  "TGGGhGGGGGGPGGPGGGGGGGGhGGGGGGT", //10 cueva zona oeste (8,10)
  "TGGGGGGGGGGPGGPGGGGGGGGGGGGGGT", //11
  "TGGGGGGGGGGPGGPGGGGGGGGGGGGGGT", //12
  "TGGRGGGGGGGPGGPGGGGGGGRGGGGGGT", //13 rocas
  "TGGGGGGGGGGPGGPGGAGGGGGGGGGGGGT", //14 árbol enorme en (15,18)?? ajustar abajo
  "TGGGGGGGGGGPGGPGGAGGGGGGGGGGGT", //15
  "TGGGGGGGGGGPGGPGGAGGGGGfGGGGGT", //16
  "TGGGGGGGGGGPAAAPGGAGfGGGGGGGGT", //17 piedra misteriosa ruina
  "TGGGGGGGGGGPAFAAPGGAGGGGGGGGGT", //18 árbol enorme + ruina
  "TGGGGGGGGGGPAAAPGGAGGGGGGGGGGT", //19
  "TGGGGGGGGGGPGGPGGAGGGGGGGGGGGT", //20 cascada zona este (24,8) ya agua? pondremos water vertical
  "TGGfGGGGGGGPGGPGGAGGGGGfGGGGGT", //21
  "TGGGGGGGGGGBBBBBBAGGGGGGGGGGGT", //22 segundo puente
  "TWWWWWWWWWBUUUUBAWWWWWWWWWWWWW", //23 agua
  "TGGGGGGGGGGBBBBBBAGGGGGGGGGGGT", //24
  "TGGGGGGGGGGPGGPGGAGfGGGGGGGGGT", //25 zona escondida este (26,26)
  "TGfGGGGhGGGPGGPGhAGGGGGGGGGGGT", //26 hierba alta
  "TTTTTTTTTTTTPPPTTTATTTTTTTTTTTT", //27 salida sur (temporal bloqueada)
];

function build(): number[][] {
  const m = parseLayout(LAYOUT);
  // Ajustar entradas/salidas warp
  m[0][15] = 7; m[0][16] = 7; m[0][17] = 7; // entrada norte → Villa
  m[27][14] = 9; m[27][15] = 9; m[27][16] = 9; // salida sur bloqueada por valla (futura expansión)
  // Cueva pequeña oeste (8,10) → warp interior cueva? Por ahora solo deco bloqueada pero dejaremos puerta
  m[10][8] = 7; // cueva entrada
  // Cascada este: columna agua en x 24-25, y 18-24 ya hay agua, añadir deco
  m[20][24] = 2; m[21][24] = 2; m[22][24] = 10; // puente ya
  // Árbol enorme en (10,18) y (15,18)
  m[18][10] = 5; // árbol enorme
  m[18][15] = 5;
  // Piedra misteriosa / ruina en (14,18)
  m[18][14] = 11; m[17][14] = 11; m[17][15] = 11;
  // Zona escondida este: clearing en (26,20)
  m[20][26] = 0; m[21][26] = 0; m[26][26] = 8; // flower clearing
  // Decorar hierba alta ya con 12, añadir más
  m[26][8] = 12; m[26][14] = 12;
  return m;
}

export const RUTA_AURELIA_MAP = build();

export const RUTA_WARPS: Warp[] = [
  { x:15, y:0, to:'villa_aurelia' as ZoneId, toX:14, toY:22, facing:'north' },
  { x:16, y:0, to:'villa_aurelia' as ZoneId, toX:15, toY:22, facing:'north' },
  { x:17, y:0, to:'villa_aurelia' as ZoneId, toX:15, toY:22, facing:'north' },
  // Cueva → por ahora vuelve al mismo punto (placeholder interior futuro)
  { x:8, y:10, to:'ruta_aurelia' as ZoneId, toX:9, toY:10, facing:'east' },
];

export const RUTA_SIGNS: SignDef[] = [
  { x:16, y:2, text: ["Ruta Aurelia — Norte", "Al norte: Villa Aurelia. Al sur: lo desconocido."] },
  { x:8, y:9, text: ["Cueva Susurrante", "Un aire frío sale del interior. Aún no puedes entrar... pero oyes un tintineo."] },
  { x:24, y:7, text: ["Puente de los Lamentos", "Bajo él corre el Río Zarco. Dicen que las Asterias de agua juegan aquí de noche."] },
  { x:14, y:17, text: ["Ruina del Primer Observador", "Piedras grabadas con constelaciones. Alguien las estudia cada amanecer."] },
  { x:10, y:19, text: ["Árbol Madre", "Sus raíces abrazan la ruta. Los niños de Villa Aurelia dejan cintas aquí."] },
  { x:26, y:21, text: ["Claro Escondido", "Un círculo de flores donde el viento no sopla. Ideal para descansar."] },
  { x:14, y:27, text: ["Camino bloqueado", "Roca desprendida. El investigador dice que pronto abrirá el paso al sur."] },
];
